<div class="kpi-config-container">
    <div class="loading" *ngIf="loading"></div>
    <div class="breadcrumb">
        <span class="intelligent-advisor-text" (click)="navigateToLanding()">Intelligent Advisor</span>
        <span class="configure-kpi-text"> / {{navigationLabel}}</span>
    </div>
    <div class="main-title">
        {{mainTitle}}
    </div>
<div class="containerBody">
    <div class="kpi-selection-container">
        <div class="left-section">
            <div class="step">
                <span class="step-icon">
                     <img src="" class="stepOneIcon"/>
                </span>
                <span class="step-text">
                    KPI Selection
                </span>
            </div>
        </div>
        <div class="right-section">
            <div class="right-section-top-container">
                <span class="right-section-title">
                    <div class="title">
                        KPI Selection
                    </div>
                    <div class="note">
                        Note: {{note}}
                    </div>
                </span>
                <span *ngIf="mode === 0" class="add-kpi-button">
                    <button (click)="onSelectKpiClicked()" [disabled]="configuredCount > 0 && count != 0">
                        <div [ngClass]="{'border-enabled': configuredCount == 0 || count == 0, 'border-disabled': configuredCount > 0 && count != 0}">
                            <div [ngClass]="{'add-kpi-button-text-enabled': configuredCount == 0 || count == 0, 'add-kpi-button-text-disabled': configuredCount > 0 && count != 0}">
                                SELECT KPIS
                                <img *ngIf="configuredCount == 0 || count == 0" class="add-kpi-button-icon addIcon" src=""/>
                                <img *ngIf="configuredCount > 0 && count != 0" class="add-kpi-button-icon" src="assets/add-button-disabled.svg"/>
                            </div>
                        </div>
                    </button>
                </span>
            </div>

            <div class="kpi-list-container">
                <div class="count-paginator-container">
                    <div class="kpi-count" [ngClass]="{'no-kpis': count === 0, 'edit-mode': mode === 1}">
                        {{count > 1 ? "KPIS" : "KPI"}} ({{count}})
                    </div>
                    <div class ="paginator" [hidden]="count === 0 || mode ===1">
                        <mat-paginator #scheduledOrdersPaginator [hidePageSize]="true" [pageSizeOptions]="[6]" showFirstLastButtons></mat-paginator>
                    </div>
                </div>
                <div class="line-divider">
                    <div class="circle"></div>
                    <div class="line"></div>
                    <div class="circle"></div>
                </div>
                <div class="table-container">
                    <div class="no-kpi-message" [hidden]="count > 0">
                        <img class="icon infoIcon" src=""/>
                        <div class="message">NO KPIS HAVE BEEN ADDED</div>
                        <div class="note">Click “Select KPIs” to Assign KPIs</div>
                    </div>
                    <div class="selected-kpis-container" [hidden]="count === 0">
                        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0">
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by actionTitle">
                                Name
                              </th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <span appTooltip="{{kpi?.insightCategoryParameters?.name}}" [tooltipPosition]="'top'"
                                [tooltipShow]="((kpi?.insightCategoryParameters?.name)?.length) > 24">
                                    <div class="kpi-options-text">
                                        {{(kpi?.insightCategoryParameters?.name) | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="role">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dateCreated">
                                Role
                              </th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <span appTooltip="{{kpi?.role?.roleName}}" [tooltipPosition]="'top'"
                                [tooltipShow]="((kpi?.role?.roleName)?.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi?.role?.roleName | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="department">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by actionBy">
                                Department
                              </th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <span appTooltip="{{kpi?.department?.departmentName}}" [tooltipPosition]="'top'"
                                [tooltipShow]="((kpi?.department?.departmentName)?.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi?.department?.departmentName | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="ahLevel">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by status">
                                AH Level
                              </th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <span appTooltip="{{kpi?.insightCategoryParameters.assetHierarchyLevel}}" [tooltipPosition]="'top'"
                                [tooltipShow]="((kpi.insightCategoryParameters.assetHierarchyLevel)?.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi?.insightCategoryParameters.assetHierarchyLevel | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="frequency">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by assignedTo">
                                Frequency
                              </th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <span appTooltip="{{kpi?.insightCategoryParameters.frequency}}" [tooltipPosition]="'top'"
                                [tooltipShow]="((kpi.insightCategoryParameters.frequency)?.length) > 24">
                                    <div class="kpi-options-text">
                                        {{kpi?.insightCategoryParameters.frequency | shorten: 24}}
                                    </div>
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="actionIn">
                              <th mat-header-cell *matHeaderCellDef>
                                Action in
                              </th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <div class="action-in-dropdown-container">
                                    <mat-form-field>
                                        <mat-select [(ngModel)]="kpi.actionIn" (ngModelChange)="updateSelectedKpi(kpi)" [disabled]="kpi?.insightCategoryParameters.configured == true && mode === 0" (selectionChange)="editActionIn($event.value)" disableOptionCentering>
                                            <mat-option selected disabled [value]="kpi?.actionIn" [style.display]="true ? 'none' : 'block'">
                                                {{kpi?.actionIn?.value}} {{kpi?.actionIn?.unit}}{{kpi?.actionIn?.value > 1 ? 's' : ''}}
                                            </mat-option>
                                            <mat-option *ngFor="let option of actionInOptions" [value]="option">
                                                {{option?.value}} {{option?.unit}}{{option?.value > 1 ? 's' : ''}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="buttons">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let kpi" [ngClass]="{'configured-kpi': kpi?.insightCategoryParameters.configured === true && mode === 0}">
                                <div class="table-icons">
                                    <button *ngIf="mode === 0" (click)="deleteSelectedKpi(kpi)">
                                        <img *ngIf="kpi?.insightCategoryParameters.configured == false" class="delete-asset-button-icon show deleteIcon" src=""/>
                                        <img *ngIf="kpi?.insightCategoryParameters.configured == true" class="delete-asset-button-icon red" src="assets/delete-button-red.svg"/>
                                    </button>
                                </div>
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="buttons-container">
        <div class="buttons-sub-container">
            <span class ="cancel-button">
                <button (click)="navigateToLanding()">
                    <div class="cancel-button-text">
                        CANCEL
                    </div>
                </button>
            </span>
            <span class ="delete-submit-button">
                <span *ngIf="configuredCount > 0 && count > 0" class ="delete-button">
                    <button (click)="deleteConfiguredKpis()">
                        <div class="delete-button-text">
                            DELETE DUPLICATES
                        </div>
                    </button>
                </span>
                <span class ="submit-button">
                    <button *ngIf="mode === 0" (click)="submitSelectedKpis(selectedKPIs, selectedConfigType)" [ngClass]="{'submit-button-disabled': count === 0 || configuredCount > 0, 'submit-button-enabled' : count > 0 && configuredCount < 1}" [disabled]="count === 0 || configuredCount > 0 || disabled === true">
                        <div class="submit-button-text">
                            SUBMIT CONFIGURATION
                        </div>
                    </button>
                    <button *ngIf="mode === 1" (click)="saveEditKpi(configuredKPI)" [ngClass]="{'submit-button-disabled': disabled === true, 'submit-button-enabled' : disabled === false}" [disabled]="disabled === true">
                        <div class="submit-button-text">
                            SAVE CONFIGURATION
                        </div>
                    </button>
                </span>
            </span>
        </div>
    </div>
</div>
</div>

